import { render, staticRenderFns } from "./KirchengemeindenTable.vue?vue&type=template&id=5cdc4066&scoped=true&"
import script from "./KirchengemeindenTable.vue?vue&type=script&lang=js&"
export * from "./KirchengemeindenTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cdc4066",
  null
  
)

export default component.exports